module.exports = __webpack_public_path__ + "static/media/obstacleIcon.fee48049.svg";